import { string, mixed, number, boolean } from "yup";
import { messages } from "./messages";
import {
  CURRENCY_CODES,
  PAYMENT_METHODS_REGEX,
  PURCHASE_MIN_MONEY,
  LIMIT_PASSENGERS,
  TIME_REGEX,
  SEARCH_TYPE,
  ISO_31661_ALPHA2,
  PNR_REGEX,
  IATA_CODE_REGEX,
  DATE_REGEX,
  DATE_TIME_REGEX,
  PRODUCT_BRAND,
  POS_REGEX,
  CUSTOMER_FFP_CATEGORIES,
  MULTIPLE_STRING_REGEX,
  CABINS,
  PASSENGER_TYPE,
  DIGITAL_SERVICES,
  PRODUCT_CATEGORY_LEVEL_ONE,
  CLICK_TYPES,
  FEEDBACK_VALUES,
  UUID_REGEX,
  FLIGHT_NUMBER_REGEX,
  TRAVEL_TYPES,
  SEGMENT_OPERATOR_REGEX,
} from "../business/keys";

export const stringRequired = string().required();
export const stringEnsure = string().ensure();
export const message = string().min(3, messages.MIN_LEN);
export const name = string().min(3, messages.MIN_LEN);
export const currency = mixed().oneOf(CURRENCY_CODES,
  'currency key has not valid ISO-4217 value',
);
export const monetaryValue = number().min(PURCHASE_MIN_MONEY, messages.MIN_NUM);
export const paymentType = string().matches(PAYMENT_METHODS_REGEX,
  'paymentType key is not a valid value.',
);
export const resultsType = stringEnsure;
export const numberRequired = number().required();
export const numberEnsure = number();
export const firstDeparture = string().matches(TIME_REGEX,
  'firstDeparture key has not valid Time value.',
);
export const lastDeparture = string().matches(TIME_REGEX,
  'lastDeparture key has not valid Time value.',
);
export const transactionName = string().min(4, messages.MIN_LEN);
export const originCountry = mixed().oneOf(ISO_31661_ALPHA2,
  'originCountry key has not valid ISO 3166-1 Alpha2 value.',
);
export const destinationCountry = mixed().oneOf(ISO_31661_ALPHA2,
  'destinationCountry key has not valid ISO 3166-1 Alpha2 value.',
);
export const booleanValue = boolean();
export const passengerType = mixed().oneOf(PASSENGER_TYPE,
  'passengerType key has not valid value.',
);
export const adults = number().max(LIMIT_PASSENGERS.ADULTS, messages.MAX_NUM);
export const children = number().max(LIMIT_PASSENGERS.CHILDREN, messages.MAX_NUM);
export const infants = number().max(LIMIT_PASSENGERS.INFANTS, messages.MAX_NUM);
export const originAirport = string().matches(IATA_CODE_REGEX,
  'originAirport key has not valid IATA Code value.',
);
export const destinationAirport = string().matches(IATA_CODE_REGEX,
  'destinationAirport key has not valid IATA Code value.',
);
export const originCity = string().matches(IATA_CODE_REGEX,
  'originCity key has not valid IATA Code value.',
);
export const destinationCity = string().matches(IATA_CODE_REGEX,
  'destinationCity key has not valid IATA Code value.',
);
export const date = string().matches(DATE_REGEX,
  'The date key has not valid Date value.',
);
export const departureDateTime = string().matches(DATE_TIME_REGEX,
  'departureDateTime key has not valid Datetime value.',
);
export const arrivalDate = string().matches(DATE_TIME_REGEX,
  'arrivalDate key has not valid Datetime value.',
);
export const returnDateTime = string().matches(DATE_TIME_REGEX,
  'returnDateTime key has not valid Datetime value.',
);
export const departureDate = string().matches(DATE_REGEX,
  'departureDate key has not valid Date value.',
);
export const returnDate = string().matches(DATE_REGEX,
  'returnDate key has not valid Date value.',
);
export const cabinType = mixed().oneOf(CABINS,
  'cabinType key is not a valid value.',
);
export const flightBrand = mixed().oneOf(PRODUCT_BRAND,
  'The brand is not valid for this product object.',
);
export const country = string().required().matches(POS_REGEX,
  'The country key is invalid.',
);
export const pnr = string().matches(PNR_REGEX,
  'The PNR key has not valid PNR value.',
);
export const errorCode = string();
export const ffpCategory = mixed().oneOf(CUSTOMER_FFP_CATEGORIES,
  'The Customer FFP Category is not valid.',
);
export const stringMultiple = string().matches(MULTIPLE_STRING_REGEX,
  'The value entered is not valid',
);
export const digitalServiceType = mixed().oneOf(DIGITAL_SERVICES,
  'The digital service type is not valid.',
);
export const productTypes = mixed().oneOf(PRODUCT_CATEGORY_LEVEL_ONE,
  'The product type is not valid.',
);
export const searchType = mixed().oneOf(SEARCH_TYPE,
  'The search type is not a valid value.',
);
export const clickType = mixed().oneOf(CLICK_TYPES,
  'The click type is not valid.',
);
export const feedbackValue = string().matches(FEEDBACK_VALUES,
  'The feedback value is not valid.',
);
export const trackId = string().matches(UUID_REGEX,
  "trackId key is not a valid uuid value."
);
export const flightNumber = string().matches(FLIGHT_NUMBER_REGEX,
  'The flight number is not valid.',
);
export const travelType = mixed().oneOf(TRAVEL_TYPES,
  'travelType key has not valid value.',
);
export const segmentOperator = string().matches(SEGMENT_OPERATOR_REGEX,
  'The segment operator is not valid.',
);
export const action = stringEnsure;
export const clickProductTypes = mixed().oneOf(
  ['Others', 'Destinations', 'Non-Revenue Activities'],
  'The click product type is not valid.',
).nullable().optional();